// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-upload-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}
.bulk-upload-overlay .bulk-upload-panel {
  background: #fff;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease;
}
@media (max-width: 600px) {
  .bulk-upload-overlay .bulk-upload-panel {
    border-radius: 0.75rem;
    max-width: 100%;
  }
}
.bulk-upload-overlay .bulk-upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #eee;
  background: #f9fafb;
  order: 0;
}
.bulk-upload-overlay .bulk-upload-header .title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
}
.bulk-upload-overlay .bulk-upload-header .close-btn {
  border: none;
  background: transparent;
  font-size: 1.2rem;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}
.bulk-upload-overlay .bulk-upload-header .close-btn:hover {
  color: #000;
}
.bulk-upload-overlay .bulk-upload-body {
  padding: 1.5rem;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .desc {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #555;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines {
  margin: 0;
  padding-left: 1.2rem;
  color: #666;
  font-size: 0.9rem;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines li {
  margin-bottom: 0.4rem;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines .link {
  color: #1571b9 !important;
  cursor: pointer;
  text-decoration: underline;
}
.bulk-upload-overlay .bulk-upload-body .upload-info .guidelines .link:hover {
  color: #0056b3;
}
.bulk-upload-overlay .bulk-upload-body .dropzone {
  margin-top: 1.5rem;
  border: 2px dashed #ccc;
  border-radius: 0.75rem;
  text-align: center;
  padding: 2rem;
  transition: all 0.3s ease;
  cursor: pointer;
}
.bulk-upload-overlay .bulk-upload-body .dropzone.dragging {
  background: #f0f8ff;
  border-color: #1571b9;
}
.bulk-upload-overlay .bulk-upload-body .dropzone input[type=file] {
  display: none;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  color: #444;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label .icon {
  font-size: 2rem;
  color: #1571b9;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label .text {
  font-size: 0.95rem;
}
.bulk-upload-overlay .bulk-upload-body .dropzone .dropzone-label small {
  color: #777;
  font-size: 0.85rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section {
  margin-top: 1.5rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header .sub-title {
  font-weight: 500;
  font-size: 1rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header .clear-btn {
  background: transparent;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-weight: 500;
}
.bulk-upload-overlay .bulk-upload-body .files-section .files-header .clear-btn:hover {
  text-decoration: underline;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li {
  background: #f9fafc;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li.error {
  border-left: 4px solid #dc3545;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .meta .file-name {
  font-weight: 500;
  max-width: 58em;
  border: none;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .meta .file-size {
  color: #777;
  font-size: 0.85rem;
  padding: 0em 1.2em;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .meta .error-msg {
  color: #dc3545;
  font-size: 0.8rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .remove-file-btn {
  border: none;
  background: transparent;
  color: #888;
  cursor: pointer;
  font-size: 1.1rem;
}
.bulk-upload-overlay .bulk-upload-body .files-section .file-list li .file-info .remove-file-btn:hover {
  color: #dc3545;
}
.bulk-upload-overlay .preview-section {
  padding: 1.5rem;
}
.bulk-upload-overlay .preview-section .info-banner {
  background: #e9f6ff;
  border-left: 4px solid #1571b9;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  color: #004b9a;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bulk-upload-overlay .preview-section .table-wrapper {
  overflow-x: auto;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table th,
.bulk-upload-overlay .preview-section .table-wrapper .data-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #e6e6e6;
  text-align: left;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table th {
  background: #f1f3f6;
  font-weight: 600;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table tr:hover {
  background: #fafafa;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table .icon-btn.danger {
  color: #dc3545;
  background: transparent;
  border: none;
  cursor: pointer;
}
.bulk-upload-overlay .preview-section .table-wrapper .data-table .icon-btn.danger:hover {
  color: #b52b3a;
}
.bulk-upload-overlay .bulk-upload-footer {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid #eee;
  background: #f9fafb;
}
.bulk-upload-overlay .bulk-upload-footer .btn {
  padding: 0.6rem 1.2rem;
  border-radius: 0.5rem;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-primary {
  background: #1571b9;
  color: #fff;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-primary:hover {
  background: #005ecb;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-primary.loading {
  opacity: 0.6;
  cursor: not-allowed;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-secondary {
  background: #e4e6eb;
  color: #333;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-secondary:hover {
  background: #d6d8dc;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-outline {
  background: transparent;
  border: 1px solid #1571b9;
  color: #1571b9;
}
.bulk-upload-overlay .bulk-upload-footer .btn.btn-outline:hover {
  background: #1571b9;
  color: #fff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/userandgroup/bulk-upload/bulk-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AACJ;AACI;EAZF;IAaI,sBAAA;IACA,eAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,QAAA;AACJ;AAEI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAAN;AAGI;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AADN;AAGM;EACE,WAAA;AADR;AAME;EACE,eAAA;AAJJ;AAOM;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;AALR;AAQM;EACE,SAAA;EACA,oBAAA;EACA,WAAA;EACA,iBAAA;AANR;AAQQ;EACE,qBAAA;AANV;AASQ;EACE,yBAAA;EACA,eAAA;EACA,0BAAA;AAPV;AASU;EACE,cAAA;AAPZ;AAaI;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AAXN;AAaM;EACE,mBAAA;EACA,qBAAA;AAXR;AAcM;EACE,aAAA;AAZR;AAeM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AAbR;AAeQ;EACE,eAAA;EACA,cAAA;AAbV;AAgBQ;EACE,kBAAA;AAdV;AAiBQ;EACE,WAAA;EACA,kBAAA;AAfV;AAoBI;EACE,kBAAA;AAlBN;AAoBM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAlBR;AAoBQ;EACE,gBAAA;EACA,eAAA;AAlBV;AAqBQ;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnBV;AAqBU;EACE,0BAAA;AAnBZ;AAwBM;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAtBR;AAwBQ;EACE,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAtBV;AAwBU;EACE,8BAAA;AAtBZ;AAyBU;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAvBZ;AA0Bc;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAxBhB;AA2Bc;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AAzBhB;AA4Bc;EACE,cAAA;EACA,iBAAA;AA1BhB;AA8BY;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AA5Bd;AA8Bc;EACE,cAAA;AA5BhB;AAqCE;EACE,eAAA;AAnCJ;AAqCI;EACE,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAnCN;AAsCI;EACE,gBAAA;AApCN;AAsCM;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AApCR;AAsCQ;;EAEE,gBAAA;EACA,gCAAA;EACA,gBAAA;AApCV;AAuCQ;EACE,mBAAA;EACA,gBAAA;AArCV;AAwCQ;EACE,mBAAA;AAtCV;AAyCQ;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAvCV;AAyCU;EACE,cAAA;AAvCZ;AA8CE;EACE,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AA5CJ;AA8CI;EACE,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA5CN;AA8CM;EACE,mBAAA;EACA,WAAA;AA5CR;AA8CQ;EACE,mBAAA;AA5CV;AA+CQ;EACE,YAAA;EACA,mBAAA;AA7CV;AAiDM;EACE,mBAAA;EACA,WAAA;AA/CR;AAiDQ;EACE,mBAAA;AA/CV;AAmDM;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AAjDR;AAmDQ;EACE,mBAAA;EACA,WAAA;AAjDV;;AAwDA;EACE;IACE,UAAA;IACA,sBAAA;EArDF;EAwDA;IACE,UAAA;IACA,mBAAA;EAtDF;AACF","sourcesContent":[".bulk-upload-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 1rem;\n\n  .bulk-upload-panel {\n    background: #fff;\n    width: 100%;\n    max-width: 700px;\n    max-height: 90vh;\n    overflow-y: auto;\n    border-radius: 1rem;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    display: flex;\n    flex-direction: column;\n    animation: fadeIn 0.3s ease;\n\n    @media (max-width: 600px) {\n      border-radius: 0.75rem;\n      max-width: 100%;\n    }\n  }\n\n  .bulk-upload-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.25rem 1.5rem;\n    border-bottom: 1px solid #eee;\n    background: #f9fafb;\n    order: 0;\n\n\n    .title {\n      font-size: 1.25rem;\n      font-weight: 600;\n      color: #333;\n      margin-bottom: 0;\n    }\n\n    .close-btn {\n      border: none;\n      background: transparent;\n      font-size: 1.2rem;\n      cursor: pointer;\n      color: #666;\n      transition: color 0.2s;\n\n      &:hover {\n        color: #000;\n      }\n    }\n  }\n\n  .bulk-upload-body {\n    padding: 1.5rem;\n\n    .upload-info {\n      .desc {\n        margin-bottom: 0.5rem;\n        font-size: 0.95rem;\n        color: #555;\n      }\n\n      .guidelines {\n        margin: 0;\n        padding-left: 1.2rem;\n        color: #666;\n        font-size: 0.9rem;\n\n        li {\n          margin-bottom: 0.4rem;\n        }\n\n        .link {\n          color: #1571b9 !important;\n          cursor: pointer;\n          text-decoration: underline;\n\n          &:hover {\n            color: #0056b3;\n          }\n        }\n      }\n    }\n\n    .dropzone {\n      margin-top: 1.5rem;\n      border: 2px dashed #ccc;\n      border-radius: 0.75rem;\n      text-align: center;\n      padding: 2rem;\n      transition: all 0.3s ease;\n      cursor: pointer;\n\n      &.dragging {\n        background: #f0f8ff;\n        border-color: #1571b9;\n      }\n\n      input[type=\"file\"] {\n        display: none;\n      }\n\n      .dropzone-label {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.4rem;\n        color: #444;\n\n        .icon {\n          font-size: 2rem;\n          color: #1571b9;\n        }\n\n        .text {\n          font-size: 0.95rem;\n        }\n\n        small {\n          color: #777;\n          font-size: 0.85rem;\n        }\n      }\n    }\n\n    .files-section {\n      margin-top: 1.5rem;\n\n      .files-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 0.75rem;\n\n        .sub-title {\n          font-weight: 500;\n          font-size: 1rem;\n        }\n\n        .clear-btn {\n          background: transparent;\n          border: none;\n          color: #dc3545;\n          cursor: pointer;\n          font-weight: 500;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .file-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n\n        li {\n          background: #f9fafc;\n          border-radius: 0.5rem;\n          padding: 0.75rem 1rem;\n          margin-bottom: 0.5rem;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n\n          &.error {\n            border-left: 4px solid #dc3545;\n          }\n\n          .file-info {\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n\n            .meta {\n              .file-name {\n                font-weight: 500;\n                max-width: 58em;\n                border: none;\n              }\n\n              .file-size {\n                color: #777;\n                font-size: 0.85rem;\n                padding: 0em 1.2em;\n              }\n\n              .error-msg {\n                color: #dc3545;\n                font-size: 0.8rem;\n              }\n            }\n\n            .remove-file-btn {\n              border: none;\n              background: transparent;\n              color: #888;\n              cursor: pointer;\n              font-size: 1.1rem;\n\n              &:hover {\n                color: #dc3545;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .preview-section {\n    padding: 1.5rem;\n\n    .info-banner {\n      background: #e9f6ff;\n      border-left: 4px solid #1571b9;\n      padding: 0.75rem 1rem;\n      border-radius: 0.5rem;\n      font-size: 0.9rem;\n      color: #004b9a;\n      margin-bottom: 1rem;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n    }\n\n    .table-wrapper {\n      overflow-x: auto;\n\n      .data-table {\n        width: 100%;\n        border-collapse: collapse;\n        font-size: 0.9rem;\n\n        th,\n        td {\n          padding: 0.75rem;\n          border-bottom: 1px solid #e6e6e6;\n          text-align: left;\n        }\n\n        th {\n          background: #f1f3f6;\n          font-weight: 600;\n        }\n\n        tr:hover {\n          background: #fafafa;\n        }\n\n        .icon-btn.danger {\n          color: #dc3545;\n          background: transparent;\n          border: none;\n          cursor: pointer;\n\n          &:hover {\n            color: #b52b3a;\n          }\n        }\n      }\n    }\n  }\n\n  .bulk-upload-footer {\n    padding: 1rem 1.5rem;\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    border-top: 1px solid #eee;\n    background: #f9fafb;\n\n    .btn {\n      padding: 0.6rem 1.2rem;\n      border-radius: 0.5rem;\n      border: none;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.3s;\n\n      &.btn-primary {\n        background: #1571b9;\n        color: #fff;\n\n        &:hover {\n          background: #005ecb;\n        }\n\n        &.loading {\n          opacity: 0.6;\n          cursor: not-allowed;\n        }\n      }\n\n      &.btn-secondary {\n        background: #e4e6eb;\n        color: #333;\n\n        &:hover {\n          background: #d6d8dc;\n        }\n      }\n\n      &.btn-outline {\n        background: transparent;\n        border: 1px solid #1571b9;\n        color: #1571b9;\n\n        &:hover {\n          background: #1571b9;\n          color: #fff;\n        }\n      }\n    }\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
